import { Id64String } from "@itwin/core-bentley";
import { PlanarClipMaskSettings } from "@itwin/core-common";
import { BeButtonEvent, DecorateContext, Decorator, EventHandled, GraphicType, HitDetail, IModelConnection, RenderGraphic } from "@itwin/core-frontend";
import { Point3d } from "@itwin/core-geometry";
import { cView } from "./View";

export class GltfDecorator implements Decorator {
  /** A graphic created from a glTF asset. */
  private readonly _graphic: RenderGraphic;
  /** The tooltip to be displayed when the graphic is moused-over. */
  private readonly _tooltip: string;
  /** The Id of the graphic used for picking. */
  private readonly _pickableId: Id64String;



  private elementClicked: ((id: string) => void) | undefined;

  protected _decoId?: string;


  public constructor(graphic: RenderGraphic, tooltip: string, pickableId: Id64String) {
    this._graphic = graphic;
    this._tooltip = tooltip;
    this._pickableId = pickableId;

  }

  /** Tell the display system not to recreate our graphics every time the mouse cursor moves. */
  //public readonly useCachedDecorations = false;

  /** Draw our graphics into the viewport. */
  public decorate(context: DecorateContext): void {
    // Our graphics are defined in spatial coordinates so should only be drawn in a spatial view
    const vp = context.viewport;
    if (context.viewport.view.isSpatialView()) {
      // Produce a "scene" graphic so that it will be affected by lighting and other aspects of the viewport's display style.

        // Get next available Id to represent our decoration for it's life span.
      context.addDecoration(GraphicType.Scene, this._graphic);
     
    }
  }

  public getTooltip(): string {
    return this._tooltip;
  }
  /** Return true if the specified Id matches our graphic's pickable Id. */
  public testDecorationHit(id: string): boolean {
    return id === this._pickableId;
  }


  /** Provide a tooltip when our graphic is moused-over. */
  public async getDecorationToolTip(): Promise<string> {
    return this._tooltip;
  }

  public async onDecorationButtonEvent(hit: HitDetail, ev: BeButtonEvent): Promise<EventHandled> {
    console.log(this._pickableId);
    //this.createMask();
    return EventHandled.Yes;
  }

  // public createMask() {
  //   const maskModel = this.getPickableId();
  //   const mask = PlanarClipMaskSettings.create({
  //     modelIds: [maskModel],
  //     transparency: 0,
  //   });

  //   cView.makeMask(mask);
  // }

  
  public getPickableId() { 
    return this._pickableId;
  }

}

export class GltfPlacement {
  private static iModel : IModelConnection;
  public static initGltfPlacement (iModel: IModelConnection) {
    this.iModel = iModel;
  }
  // public static placeAsset(point: Point3d) {
  //   displayGltfAsset(point,this.iModel).then((status) => {
  //     console.log(status);
  //   }).catch((err) => {
  //     console.error("Error:", err);
  //   });
  // }
}